/* eslint-disable */
import { Theme, makeStyles, createStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    treeView: {
      paddingTop: theme.spacing(2),
      userSelect: "none",
      height: "100%",
      flexGrow: 1,
      width: "100%",
    },
    treeGroup: {
      padding: theme.spacing(1, 0),
    },
  })
);

export const useParentStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    selected: {
      "& $content": {
        background: "none !important",
      },
      "& $label": {
        background: "none !important",
      },
    },
    content: {
      borderRadius: "4px",
      padding: "6px",
      height: "32px",
    },
    label: {
      color: "rgba(39, 58, 57, 0.8)",
      fontSize: "12px",
      lineHeight: "100%",
      fontWeight: "bold",
      background: "none !important",
      textTransform: "uppercase",
    },
  })
);

export const useItemStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginBottom: "2px",
    },
    content: {
      marginLeft: "-32px",
      minHeight: "32px",
      width: "calc(100% + 32px)",
      alignItems: "stretch",
    },
    iconContainer: {
      order: 2,
      marginLeft: theme.spacing(0.5),
      borderRadius: 4,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: theme.spacing(0, 1),
      marginRight: 0,
      width: "auto",
      flex: "0 0 auto",
      "&:hover": {
        background: "rgba(51, 51, 51, 0.05)",
      },
    },
    label: {
      color: "rgba(39, 58, 57, 0.8)",
      fontSize: "12px",
      lineHeight: "100%",
      fontWeight: "bold",
      background: "none",
      borderRadius: "4px",
      padding: "6px",
      paddingLeft: "28px",
      display: "flex",
      alignItems: "center",
      "&:hover": {
        background: "rgba(51, 51, 51, 0.05) !important",
      },
    },
    selected: {
      "& $label": {
        background: "rgba(101, 172, 30, 0.2)",
        color: "#65AC1E",
      },
    },
  })
);
